import React from "react";
import Icon from "app/components/Icon";
import { IconComponent } from "app/components/Icon/types";
import styles from "app/components/Checkout/shared-styles.module.scss";

interface Props {
  icon: IconComponent;
  onClick: () => void;
  text: string;
}

export function ToggleIconText({ icon, onClick, text }: Props) {
  return (
    <div className={styles.toggleText}>
      <div onClick={onClick}>
        <Icon
          as={icon}
          mr={2}
          width={{ _: "11px", lg: "17px" }}
          height={{ _: "11px", lg: "17px" }}
        />
        <p>{text}</p>
      </div>
    </div>
  );
}
